import { createContext } from 'react';
import { IAuth } from '../../../../../utils/Interface/AuthInterface';

export const AuthContext = createContext<IAuth | undefined>(undefined);
